import axiosInstance from '@/api/axiosInstance';
import { DeleteCourseResponse } from './types';

/**
 * Delete a course
 * DELETE /api/learning-center/courses/:id
 * Requires ROLE_LEARNING_ADMIN or ROLE_SUPER_ADMIN
 */
export const deleteCourse = async (id: number): Promise<DeleteCourseResponse> => {
  try {
    const response = await axiosInstance.delete<DeleteCourseResponse>(
      `/api/learning-center/courses/${id}`
    );
    return response.data;
  } catch (error) {
    console.error(`Error deleting course ${id}:`, error);
    throw error;
  }
};
